import {FunctionComponent, Fragment} from "react";
import {Garage, OpeningHours, Review, Service} from "@App/types";

type SchemaMarkupProps = {
    garage?: Garage
}

export const SchemaMarkup: FunctionComponent<SchemaMarkupProps> = (({garage}: SchemaMarkupProps) => {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    return (
        <Fragment>
            {garage && (
                <script type="application/ld+json" dangerouslySetInnerHTML={
                    {
                        __html: JSON.stringify({
                            "@context": "https://schema.org/",
                            "@type": "AutoRepair",
                            "name": `${garage.name}`,
                            "image": `${process.env.NEXT_PUBLIC_BACKEND_URL}storage/${garage.cover_image}`,
                            "telephone": garage.phone,
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": garage.street,
                                "addressLocality": garage.city,
                                "postalCode": garage.postcode,
                                "addressCountry": "DE"
                            },
                            "geo": {
                                "@type": "GeoCoordinates",
                                "latitude": garage.lat,
                                "longitude": garage.lon
                            },
                            "url": `${process.env.NEXT_PUBLIC_BASE_URL}werkstatt/${garage.profileSlug?.split('/')[0]}/${garage.id}-${garage.profileSlug?.split('/')[1]}/`,
                            "description": garage.description?.replace(/(<([^>]+)>)/gi, " ").substring(0, 120),
                            "openingHoursSpecification": [
                                garage.opening_hours && (
                                    garage.opening_hours.map((day: OpeningHours, idx: number) => {
                                        if (day.open !== 'geschlossen') {
                                            return {
                                                    "@type": "OpeningHoursSpecification",
                                                    "dayOfWeek": `https://schema.org/${days[idx]}`,
                                                    "opens": day.open.substring(0, 5).replace('.', ':'),
                                                    "closes": day.open.substring(8, 13).replace('.', ':')
                                                }
                                        }
                                    })
                                )
                            ],
                            "aggregateRating": garage?.review_count ? {
                                "@type": "AggregateRating",
                                "bestRating": "100",
                                "ratingValue": garage?.rating,
                                "reviewCount": garage?.review_count
                            } : undefined,
                            "review": garage?.reviews?.data ? [
                                garage?.reviews?.data?.map((review: Review) => {
                                return {
                                        "@type": "Review",
                                        "author": {
                                            "@type": "Person",
                                            "name": review?.author
                                        },
                                        "datePublished": review?.published_at,
                                        "reviewBody": review?.comment,
                                        "reviewRating": {
                                            "@type": "Rating",
                                            "bestRating": "100",
                                            "ratingValue": review?.rating,
                                            "worstRating": "1"
                                        }
                                    }
                                })
                            ] : undefined,
                            "hasOfferCatalog": {
                                "@type": "OfferCatalog",
                                "name": "AutoRepair",
                                "itemListElement": [
                                    garage?.availableServices?.map((service: Service) => {
                                        return {
                                            "@type": "Offer",
                                            "itemOffered": {
                                                "@type": "Service",
                                                "name": service?.name.replace(/['"]+/g, '')
                                            }
                                        }
                                    })
                            ]
                        }
                    })
                }}/>
            )}
        </Fragment>
    )
})
